import type { WalletFormFields } from './types'

// Edit these strings to change the labels shown for each connection mode.
// Keep the keys as-is; they are internal values used by the modal logic.
export const connectionModeLabels: Record<WalletFormFields['connectionMode'], string> = {
  automatic: 'Automatic',
  manual: 'Manual',
  smei: 'Smei',
}
